<template>
  <div
    class="Projects w-full h-screen overflow-y-auto bg-black text-white flex justify-center leading-loose items-start content-start xl:items-center xl:content-center"
  >
    <h1 class="text-transparent fixed">Architect Serving Launceston and Devonport</h1>
    <div
      class="z-20 w-full flex justify-center absolute top-0 transition duration-300 ease-in-out"
      :class="{
        'bg-black':currentProject===null
      }"
    >
      <div class="z-20 mt-16">
        <CustomSelect
          name=""
          v-model="selectedCategoryId"
          :options="categoryOptions"
        />
      </div>
    </div>
    <template
      v-for="project in sortedProjects"
    >
      <transition name="fade" :key="project.index">
        <div
          v-if="currentProject===project"
          :key="project.index"
          :style="{ backgroundImage: 'url(' + project.heroSrc + ')' }"
          class="absolute bg-cover bg-center w-full h-full bg-black"
        >
        </div>
      </transition>
    </template>
    <div class="pt-32 xl:pt-0 w-1/2 flex flex-wrap items-center justify-center">
      <h3
        @mouseover="currentProject = project"
        @mouseleave="currentProject = null"
        @click="goToProject(project)"
        v-for="(project, index) in sortedProjects" :key="index + 'name'"
        class="w-full md:w-auto text-center cursor-pointer transform hover:scale-110 duration-100 ease-in-out mr-0 md:mr-8 text-xl md:text-2xl xl:text-3xl leading-none mb-6 md:leading-loose md:mb-0"
        :class="{
        }"
      >
        {{project.name}}.
      </h3>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import CustomSelect from '@/components/elements/CustomSelect.vue'

export default {
  name: 'projects',
  components: {
    CustomSelect
  },
  metaInfo () {
    return {
      title: 'Architecture in Devonport & Launceston | Starbox Architecture',
      meta: [
        {
          name: 'description',
          content: 'Starbox Architecture is a team of Devonport-based architects that serve individuals around Launceston. Visit us online to get started!'
        },
        {
          name: 'keywords',
          content: 'starbox,architecture,starbox architecture,tasmania,tasmanian,tasmanian architecture,tasmania architecture'
        }
      ]
    }
  },
  data () {
    return {
      currentProject: null,
      projects: [],
      selectedCategoryId: 'ALL'
    }
  },
  computed: {
    categoryOptions () {
      var toReturn = []
      toReturn.push(
        {
          label: 'All Typologies',
          value: 'ALL'
        }
      )
      var temp = this.projects
      var catIdsAdded = []
      for (var i = 0; i < temp.length; i++) {
        if (temp[i].category) {
          if (!catIdsAdded.includes(temp[i].category.id)) {
            toReturn.push(
              {
                label: temp[i].category.name,
                value: temp[i].category.id
              }
            )
            catIdsAdded.push(temp[i].category.id)
          }
        }
      }
      return toReturn
    },
    sortedProjects () {
      var temp = this.projects

      var toReturn = []
      for (var j = 0; j < temp.length; j++) {
        if (this.selectedCategoryId === 'ALL') {
          toReturn.push(temp[j])
        } else if (temp[j].category) {
          if (parseInt(this.selectedCategoryId) === parseInt(temp[j].category.id)) {
            toReturn.push(temp[j])
          }
        }
      }
      return toReturn
    }
  },
  methods: {
    goToProject (project) {
      this.$router.replace('/project/' + project.id)
    },
    getProjects () {
      var toReturn = []
      axios.get(process.env.VUE_APP_ROOT_API + '/projects').then(response => {
        var data = response.data
        for (var i = 0; i < data.length; i++) {
          toReturn.push({
            id: data[i].id,
            name: data[i].name,
            category: data[i].category
          })
          if (data[i].hero_image) toReturn[i].heroSrc = data[i].hero_image.path
        }
        this.projects = toReturn
      }).catch(error => {
        console.log('Error', error)
      })
    }
  },
  mounted () {
    this.getProjects()
  },
  beforeDestroy () {
  }
}
</script>

<style lang="scss">
  $sm: '640px';
  $md: '768px';
  $lg: '1024px';
  $xl: '1280px';
  $xxl: '1920px';

  // .Projects {
  // }
</style>
